import { useSyncExternalStore } from "react";
import { connectivityService } from "@/lib/connectivityService";

/**
 * React hook wrapping the central ConnectivityService.
 * Returns { isOnline, wasOffline } reactively.
 */
export function useOnlineStatus() {
  const isOnline = useSyncExternalStore(
    (cb) => connectivityService.subscribe(cb),
    () => connectivityService.isOnline,
    () => true, // SSR fallback
  );

  const wasOffline = useSyncExternalStore(
    (cb) => connectivityService.subscribe(cb),
    () => connectivityService.wasOffline,
    () => false,
  );

  return { isOnline, wasOffline };
}
